import React from 'react';
import { Select, MenuItem, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material';
import { iconsHeader } from '../../assets/icons/icons';
import FilterSelect from '../select/filterSelect';

const MenuItemCustom = styled(MenuItem)({
    paddingTop: '1.5em',
});

const SelectMenu = styled(Select)({
    outline: 'none !important',
    border: 'none',
    boxShadow: 'none',
    '.MuiInputBase-root': {
        border: 'none',
    },
    marginTop: '0.3em',
    '.MuiSelect-select': {
        padding: '0.5em 0.5em',
    },
});
const translationData = [
    {
        key: "THAI",
        data: 'th',
        imgUrl: iconsHeader.thai
    },
    {
        key: "ENGLISH",
        data: 'en',
        imgUrl: iconsHeader.english
    },
]

const ChangeLanguage: React.FC = () => {
    const { i18n } = useTranslation();
    const language = i18n.language


    const handleChangeLanguage = (lang: string) => {
        const langMiss: string[] = ['en', 'th'];
        if (langMiss.includes(lang)) {
            i18n.changeLanguage(lang);
            localStorage.setItem('lng', lang);
        }
        return false
    }

    return (
        <div>
            <FilterSelect
                style={{ padding: 0 }}
                onchange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangeLanguage(e.target.value)}
                value={language}
                labelId={"1"}
                selectId={"1"}
                options={translationData.map((x) => {
                    return (
                        <MenuItem value={x.data} key={x.key}>
                            <img src={x.imgUrl} alt={`lang-${x?.key}`} />
                        </MenuItem>
                    )
                })}
            />
        </div >
    );
}

export default ChangeLanguage